import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'LeadFormContainer' })(() => ({
  srOnly: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0,
  },
}));

export default useStyles;
